import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom'

import './styles/index.css'
import App from './App'
import { AuthProvider } from './features/auth/AuthContext'


const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
    <HashRouter>
      <AuthProvider>
        <App class='font-figtree'/>
      </AuthProvider>
    </HashRouter>
)
